import React, { useMemo } from "react";
import Icon from "../../../common/Icon";
import "./LicenseFilterCards.css";

interface LicenseFilterCardsProps {
  licenses?: any[];
  isLoading?: boolean;
  onFilterChange?: (filterType: string | null) => void;
  activeFilter?: string | null;
}

const LicenseFilterCards: React.FC<LicenseFilterCardsProps> = ({
  licenses = [],
  isLoading = false,
  onFilterChange,
  activeFilter = null,
}) => {
  const stats = useMemo(() => {
    if (!licenses || licenses.length === 0) {
      return {
        total: 0,
        active: 0,
        perpetual: 0,
        upForRenewal: 0,
      };
    }

    return {
      total: licenses.length,
      active: licenses.filter((l: any) => l.status === "active").length,
      perpetual: licenses.filter((l: any) => l.is_perpetual === true || l.is_perpetual === 1 || l.is_perpetual === "1").length,
      upForRenewal: licenses.filter((l: any) => l.status === "up_for_renewal")
        .length,
    };
  }, [licenses]);

  const displayValue = (value: number) => {
    return isLoading ? "..." : value;
  };

  const handleCardClick = (filterType: string | null) => {
    if (onFilterChange) {
      onFilterChange(activeFilter === filterType ? null : filterType);
    }
  };

  return (
    <div className="d-flex mb-2 card-container" style={{ gap: "12px" }}>
      <div
        className={`cards d-flex align-items-center border-0 cursor-pointer ${activeFilter === null ? 'active-card' : ''}`}
        onClick={() => handleCardClick(null)}
      >
        <div className="icon-container">
          <Icon name={"totallicense"} />
        </div>
        <div>
          <h4 className="fs-4 fw-semibold">{displayValue(stats.total)}</h4>
          <p className="m-0">Total Licenses</p>
        </div>
      </div>

      <div
        className={`cards d-flex align-items-center border-0 cursor-pointer ${activeFilter === 'active' ? 'light_green' : ''}`}
        onClick={() => handleCardClick('active')}
      >
        <div className="icon-container light_green">
          <Icon name={"activelicense"} />
        </div>
        <div>
          <h4 className="fs-4 fw-semibold">{displayValue(stats.active)}</h4>
          <p className="m-0">Active Licenses</p>
        </div>
      </div>

      <div
        className={`cards d-flex align-items-center border-0 cursor-pointer ${activeFilter === 'perpetual' ? 'light_grey' : ''}`}
        onClick={() => handleCardClick('perpetual')}
      >
        <div className="icon-container light_grey">
          <Icon name={"perpetuallicense"} />
        </div>
        <div>
          <h4 className="fs-4 fw-semibold">{displayValue(stats.perpetual)}</h4>
          <p className="m-0">Perpetual Licenses</p>
        </div>
      </div>

      <div
        className={`cards d-flex align-items-center border-0 cursor-pointer ${activeFilter === 'up_for_renewal' ? 'light_orange' : ''}`}
        onClick={() => handleCardClick('up_for_renewal')}
      >
        <div className="icon-container light_orange">
          <Icon name={"upforlicense"} />
        </div>
        <div>
          <h4 className="fs-4 fw-semibold">
            {displayValue(stats.upForRenewal)}
          </h4>
          <p className="m-0">Up for renewal</p>
        </div>
      </div>
    </div>
  );
};

export default LicenseFilterCards;
